import "core-js/modules/es.string.link.js";
var render = function render() {
  var _setup$link;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.output ? _c('a', {
    class: _setup.YM_HIDE_CONTENT,
    attrs: {
      "href": (_setup$link = _setup.link) !== null && _setup$link !== void 0 ? _setup$link : ''
    }
  }, [_vm._v("\n  " + _vm._s(_setup.output) + "\n")]) : _c('span', [_vm._v("\n  " + _vm._s(_vm.empty) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };